// src/components/ColorLegendPopup.jsx
//
// LSE-COLUMN-HEADING-TOOLTIP-OPTION-D — Option D "dot is the legend" row list.
//
// Renders only the content rows of a color-legend popup. The outer container
// (position: absolute, border, shadow, padding — see §5.5 color-legend in
// docs/style_guide.md) is owned by the caller (TH_TIP_STYLE in each table's
// Th component). This component handles layout and typography for the rows.
//
// Props:
//   rows — Array<{
//     indicator:   ReactNode  — colored dot or half-circle SVG (same component
//                               as the corresponding table cell uses)
//     label:       string     — status name, sentence case, no en-dash prefix
//     descriptor?: string     — optional parenthetical text shown in T.mid
//   }>

import React from "react";
import { T } from "../app/tokens.js";

export function dotIndicator(color, colorName) {
  return (
    <span
      data-testid="dot-indicator"
      aria-label={colorName || undefined}
      style={{ display: "inline-block", width: 12, height: 12, borderRadius: "50%", background: color, flexShrink: 0 }}
    />
  );
}

export function ColorLegendPopup({ rows = [], footer }) {
  return (
    <span data-testid="color-legend-popup" role="list" style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      {(rows ?? []).map(({ indicator, label, descriptor }, i) => (
        <span
          key={i}
          data-testid="legend-row"
          role="listitem"
          style={{ display: "flex", alignItems: "center", gap: 12 }}
        >
          {indicator}
          <span data-testid="legend-row-label" style={{ fontSize: T.fsBase, color: T.dark, fontWeight: T.fwRegular }}>
            {label}
            {descriptor && (
              <span style={{ color: T.mid }}>{" "}{descriptor}</span>
            )}
          </span>
        </span>
      ))}
      {footer}
    </span>
  );
}
